export default function DevicesController($scope, $state, gettextCatalog) {
	'ngInject';

	$scope.title = gettextCatalog.getString('Devices');
	$scope.totalUsage = 1024;

	$scope.search = function() {
		$state.go('^.search', { query: $scope.searchText });
	};

	$scope.search = function() {
		$state.go('^.search', { query: $scope.searchText });
	};
}
